import {
  BellDot,
  Clock,
  FileClock,
  FileText,
  FolderClock,
  Home,
  Megaphone,
  Menu,
  Settings,
} from "lucide-react";
import { NavLink } from "react-router-dom";

import { CongressSelect } from "@/features/congress-select/components/congress-select";
import { cn } from "@/utils";
import { useTranslation } from "react-i18next";

import { Logo } from "./logo";
import { UserProfileMenu } from "./user-profile-menu";

function MainNavigation() {
  const { t } = useTranslation();

  return (
    <div className="z-50 flex h-full flex-col pt-3 md:w-72 md:border-r">
      <div className="flex grow flex-col gap-y-3 overflow-y-auto bg-background pb-4">
        <Logo />
        <div className="border-b p-3">
          <CongressSelect />
        </div>
        <nav className="grid items-start px-3 font-medium">
          <NavLink
            to="/congress"
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                isActive && "bg-muted text-primary",
              )
            }
          >
            <Home className="size-4" />
            {t("nav.congress")}
          </NavLink>

          <NavLink
            to="/navigation"
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                isActive && "bg-muted text-primary",
              )
            }
          >
            <Menu className="size-4" />
            {t("nav.navigation")}
          </NavLink>

          <NavLink
            to="/notifications"
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                isActive && "bg-muted text-primary",
              )
            }
          >
            <BellDot className="size-4" />
            {t("nav.notifications")}
          </NavLink>

          <NavLink
            to="/advertisements"
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                isActive && "bg-muted text-primary",
              )
            }
          >
            <Megaphone className="size-4" />
            {t("nav.advertisements")}
          </NavLink>
          <NavLink
            to="/sections"
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                isActive && "bg-muted text-primary",
              )
            }
          >
            <FolderClock className="size-4" />
            {t("nav.sections")}
          </NavLink>
          <NavLink
            to="/abstracts"
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                isActive && "bg-muted text-primary",
              )
            }
          >
            <FileText className="size-4" />
            {t("nav.abstracts")}
          </NavLink>
          <NavLink
            to="/breaks"
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                isActive && "bg-muted text-primary",
              )
            }
          >
            <Clock className="size-4" />
            {t("nav.breaks")}
          </NavLink>
          <NavLink
            to="/migration-logs"
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                isActive && "bg-muted text-primary",
              )
            }
          >
            <FileClock className="size-4" />
            {t("nav.logs")}
          </NavLink>
        </nav>

        <nav className="mt-auto grid items-start px-3 font-medium">
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                isActive && "bg-muted text-primary",
              )
            }
          >
            <Settings className="size-4" />
            {t("nav.settings")}
          </NavLink>
          <div className="mt-4">
            <UserProfileMenu />
          </div>
        </nav>
      </div>
    </div>
  );
}

export { MainNavigation };
